/**
 * The desktop topbar's full height: the bar plus its hairline and the divider
 * under it. The two-level sidebar's nav panel starts this far down, behind
 * the topbar, and full-page views subtract it (below). If the topbar's height
 * changes, this is the one line to change.
 */
export const TOPBAR_PX = 45;

/**
 * The height a full-page dashboard view fills, in one place.
 *
 * Views used to size themselves as `calc(100vh - 58px)` (or 57, or 60) to sit
 * under the global topbar. They now share this value instead: below the
 * topbar from `sm` up, and below `TopNavbar` on `xs`, which the layout pads
 * the content past.
 *
 * A responsive `sx` value: use it only inside `sx` or MUI system props, never
 * in `style`.
 */
export const DASHBOARD_PAGE_HEIGHT = {
  xs: 'calc(100vh - 60px)',
  sm: `calc(100vh - ${TOPBAR_PX}px)`,
};
